import * as S from './Marquee.styles.js';
import { Marquee as BaseMarquee } from '@/components/Marquee/Marquee.js';
import { type CSS } from '@stitches/react';

export type MarqueeProps = {
  readonly $fontSize?: string;
  readonly css?: CSS;
  readonly duration?: string | undefined;
  readonly title: string | null;
};

export const Marquee = ({ $fontSize, css, duration, title }: MarqueeProps) => {
  if (!title) return null;

  const marqueeItemFontSize = $fontSize ? { fontSize: $fontSize } : {};

  return (
    <S.Container css={css}>
      <BaseMarquee
        duration={duration}
        itemSpacingValue={0}
      >
        <S.MarqueeItem css={{ ...marqueeItemFontSize }}>
          <span>{title}</span>
          <span>•</span>
        </S.MarqueeItem>
      </BaseMarquee>
    </S.Container>
  );
};
